import { MenuItem, MenuItemProps, Typography } from "@mui/material";
import { MouseEvent, ReactElement, useContext, type JSX } from "react";
import { SelectControlContext } from "./SrSelectContext";

/**
 * Select Item
 */
export type SrSelectItemProps = {
  icon?: ReactElement;
  largeItem?: boolean;
} & Omit<MenuItemProps, "onClick">; // To prevent conflict with our custom onClick

export const SrSelectItem = ({ icon, largeItem, sx, ...props }: SrSelectItemProps): JSX.Element => {
  const controlCtx = useContext(SelectControlContext);

  const handleClick = (event: MouseEvent<HTMLLIElement>) => {
    event.preventDefault();
    event.stopPropagation();
    controlCtx?.handleItemClick(props.value ?? event.currentTarget.dataset.value);
  };

  const largeItemStyle = largeItem
    ? {
        display: "flex",
        alignItems: "center",
        minHeight: "2.6em",
      }
    : {};

  return (
    <MenuItem
      {...props}
      onClick={handleClick}
      sx={[
        {
          "& svg": { mr: "14px" },
          "& > div, & > div > div": { width: "100%" },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {icon || null}
      <Typography component="div" noWrap sx={largeItemStyle}>
        {props.children}
      </Typography>
    </MenuItem>
  );
};

SrSelectItem.displayName = "SrSelectItem";
